<template>
    <form
        method="post"
        autocomplete="off"
        enctype="multipart/form-data"
        @submit.prevent="addorUpdateItem"
    >
        <div class="row pt-2">
            <div class="col-sm-12 col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="product_name">
                        Product Name
                    </label>
                    <input
                        type="text"
                        name="product_name"
                        v-model="form.product_name"
                        class="form-control"
                        placeholder="Product Name"
                        required
                        autofocus
                    />
                </div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-sm-12 col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="msrp">
                        MSRP
                    </label>
                    <input
                        type="number"
                        class="form-control"
                        min="0"
                        step="0.01"
                        v-model="form.msrp"
                        placeholder="0.00"
                    />
                </div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-sm-12 col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="cost">
                        Cost
                    </label>
                    <input
                        type="number"
                        class="form-control"
                        min="0"
                        step="0.01"
                        v-model="form.cost"
                        placeholder="0.00"
                    />
                </div>
            </div>
        </div>
        
        <button
            type="submit"
            class="mt-5 btn btn-outline-orange text-orange text-uppercase float-right"
        >
            {{ modalType == "add" ? "Add Item" : "Update Item" }}
        </button>
    </form>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useVuelidate } from "@vuelidate/core";

export default {
    props: ["modalType", "modalData"],
    emits: ["closeModal"],
    components: {},
    setup() {
        const store = useStore();

        function addMaterial(form) {
            store.dispatch("material/addMaterial", form);
        }

        function updateMaterial(form) {
            store.dispatch("material/updateMaterial", form);
        }

        return {
            store,
            addMaterial,
            updateMaterial,
        };
    },
    data() {
        return {
            form: {
                product_name: null,
                msrp: null,
                cost: null,
            },
        };
    },
    mounted() {
        this.clearFields();

        if (this.modalType == "edit") {
            this.populateData();
        }
    },
    methods: {
        populateData() {
            this.form.id = this.modalData.id;
            this.form.product_name = this.modalData.product_name;
            this.form.msrp = this.modalData.msrp;
            this.form.cost = this.modalData.cost;
        },
        addorUpdateItem() {
            if (this.modalType == "add") {
                this.form.id = null;

                window.emitter.emit("changeLoaderStatus", true);
                axios
                    .post("/api/store-item-without-sku", this.form)
                    .then((response) => {

                        window.emitter.emit("changeLoaderStatus", false);
                        window.emitter.emit("alertSuccess", {
                            message: "Item was added successfully!",
                        });

                    });
            }
            this.$emit("closeModal");
        },
        
        clearFields() {
            this.form.id = null;
            this.form.product_name = null;
            this.form.msrp = null;
            this.form.cost = null;
        },
    },
};
</script>
